export const getSystemMessages = (state) =>
  Object.values(state.systemMessages.systemMessages).filter((message) => !message.dismissed);
